import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-head-phone",
  templateUrl: "./head-phone.component.html",
  styleUrls: ["./head-phone.component.scss"],
})
export class HeadPhoneComponent implements OnInit {
  @Input()
  overrideStyle = {};

  @Input()
  disabled = false;
  constructor() {}

  ngOnInit(): void {}
}
